import $ from 'jquery';
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
require("scrolltofixed")

$('.fixed-element').scrollToFixed({
    marginTop: $(".menu-fixed").outerHeight() - 20,
    limit: function () {
        var limit = $('footer .container').offset().top - $(this).outerHeight() - 350;
        return limit;
    },
    zIndex: 888,
    minWidth: 992
});